import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Layers } from "lucide-react";
import { STACKUP_LAYERS } from "@/data/site";

export default function StackUp() {
    const [active, setActive] = useState("cu-top");
    const activeLayer = STACKUP_LAYERS.find((l) => l.id === active);

    return (
        <div className="border border-slate-200 bg-white" data-testid="stackup-explorer">
            <div className="flex items-center justify-between border-b border-slate-200 bg-navy-dark px-5 py-3.5">
                <p className="flex items-center gap-2.5 font-mono text-[10.5px] uppercase tracking-[0.18em] text-white">
                    <Layers className="h-4 w-4 text-brand-red" /> 4-Layer Stack-Up — Interactive Cross-Section
                </p>
                <p className="hidden font-mono text-[10.5px] tracking-[0.14em] text-slate-400 sm:block">SELECT A LAYER</p>
            </div>

            <div className="grid gap-8 p-6 md:grid-cols-2 md:p-8">
                {/* Cross-section */}
                <div className="flex flex-col justify-center gap-[3px]" data-testid="stackup-stack">
                    {STACKUP_LAYERS.map((l) => {
                        const isActive = active === l.id;
                        return (
                            <motion.button
                                key={l.id}
                                onClick={() => setActive(l.id)}
                                onMouseEnter={() => setActive(l.id)}
                                data-testid={`stackup-layer-${l.id}`}
                                aria-label={l.name}
                                initial={false}
                                animate={{
                                    opacity: isActive ? 1 : 0.45,
                                    scaleX: isActive ? 1.03 : 1,
                                }}
                                transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
                                className="relative w-full origin-left cursor-pointer"
                                style={{ height: l.h + 14 }}
                            >
                                <span
                                    className="absolute inset-0 rounded-[2px] border border-white/10"
                                    style={{ background: l.color }}
                                />
                                {isActive && (
                                    <motion.span
                                        layoutId="stackup-marker"
                                        className="absolute inset-y-0 -left-1.5 w-1.5 bg-brand-red"
                                    />
                                )}
                                <span className="absolute inset-y-0 right-2.5 flex items-center font-mono text-[9px] uppercase tracking-[0.14em] text-white/90">
                                    {l.name}
                                </span>
                            </motion.button>
                        );
                    })}
                </div>

                {/* Detail panel */}
                <div className="flex flex-col justify-center">
                    <p className="font-mono text-[10.5px] uppercase tracking-[0.2em] text-brand-red">Layer Detail</p>
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={active}
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -10 }}
                            transition={{ duration: 0.22 }}
                            className="mt-4 border border-slate-200 bg-slate-50 p-5"
                            data-testid="stackup-detail"
                        >
                            <h4 className="text-[15px] font-semibold text-navy">{activeLayer.name}</h4>
                            <p className="mt-2 text-[13px] leading-relaxed text-slate-600">{activeLayer.desc}</p>
                        </motion.div>
                    </AnimatePresence>
                    <p className="mt-4 text-[12px] leading-relaxed text-slate-500">
                        Illustrative 4-layer build. Your actual stack-up is finalised at the DFM review
                        stage and confirmed before production.
                    </p>
                </div>
            </div>
        </div>
    );
}
